import { Typography } from "@mui/material";

import {
	CoAppDataGridTextCellContainer,
	CoAppNameCell,
	CoAppSuperAdminTextCell,
} from "../../styled/global.styled";

export default function CoAppDataGridNameCell(props) {
	const { item, isUser = false, isCoAppSupport = false } = props;

	if (isUser) {
		const showEmailOnly =
      !isCoAppSupport && (!item.firstname || !item.lastname);
		return (
			<CoAppNameCell>
				{showEmailOnly ? (
					<Typography variant="body2" color="text.primary">
						{item.email}
					</Typography>
				) : item.firstname && item.lastname && !isCoAppSupport ? (
					<Typography variant="body2" color="text.primary">
						{item.firstname} {item.lastname}
					</Typography>
				) : (
					<CoAppSuperAdminTextCell before="true">
						{item.firstname} {item.lastname}
					</CoAppSuperAdminTextCell>
				)}
				<Typography
					variant="body2"
					color={isCoAppSupport ? "text.disabled" : "text.secondary"}
				>
					{item.email}
				</Typography>
			</CoAppNameCell>
		);
	} else {
		return (
			<CoAppDataGridTextCellContainer>
				<Typography
					title={typeof item === "object" && item !== null ? item.name : item}
					variant="body2"
					color="text.primary"
					noWrap
				>
					{typeof item === "object" && item !== null ? item.name : item}
				</Typography>
			</CoAppDataGridTextCellContainer>
		);
	}
}
